import { useStaticQuery, graphql } from "gatsby"

export  const useStrapiVideosWebinarsData = () => {
    const { allStrapiVideo } = useStaticQuery(graphql`
        query {
            allStrapiVideo(sort: {fields: date, order: DESC}) {
                nodes {
                  strapi_id
                  title
                  slug
                  author
                  description
                  keywords
                  video_url
                  video_length
                  displayOnVideosWebinarsPage
                  external_resource
                  presenters {
                    data {
                      presenters
                    }
                  }
                  body {
                    data {
                      childMarkdownRemark {
                        html
                        excerpt(format: HTML, pruneLength: 136)
                      }
                    }
                  }
                  date(formatString: "MMMM DD, YYYY")
                  thumbnail {
                    alternativeText
                    caption
                    localFile {
                        url
                        childImageSharp {
                          gatsbyImageData(layout: FULL_WIDTH)
                        }
                      }
                  }
                  transcript {
                    localFile {
                      prettySize
                      publicURL
                    }
                  }
                  video_category {
                    name
                  }
                  category {
                    name
                  }
                  topics {
                    title
                  }
                }
              }
        }
    `)
    return { allStrapiVideo }
}